module.exports = __webpack_public_path__ + "img/logo_westudy_color.fb9451b8.png";